  <template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Notification</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Notification</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Notification</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" v-show="showScheduleJob" @click="scheduleJobModal = true">
            Schedule Job
            <v-icon right>mdi-clock</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.procId }}</v-subheader>
                <div class="queryValue" v-for="item in filterProcIdList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs12 md6 v-else>
                <v-autocomplete
                  :label="labels.procId"
                  :items="procIdList"
                  v-model="form.procId"
                  item-text="value"
                  item-value="code"
                  data-vv-name="procId"
                  :data-vv-as="labels.procId"
                  :error-messages="errors.collect('procId')"
                  @change="doSetProcType"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.procType }}</v-subheader>
                <div class="queryValue" v-for="item in filterProcTypeList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs12 md6 v-else>
                <v-autocomplete
                  :label="labels.procType"
                  :items="procTypeList"
                  v-model="form.procType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="procType"
                  :data-vv-as="labels.procType"
                  :error-messages="errors.collect('procType')"
                  :disabled="true"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6 v-if="form.procType == 'A'">
                <v-text-field
                  v-model="form.alert"
                  :label="labels.alert"
                  :error-messages="errors.collect('alert')"
                  data-vv-name="alert"
                  :data-vv-as="labels.alert"
                  v-validate="'numeric|max:2'"
                  :disabled="disabledNotify"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 v-if="form.procType == 'A'">
                <v-text-field
                  v-model="form.rem1"
                  :label="labels.rem1"
                  :error-messages="errors.collect('rem1')"
                  data-vv-name="rem1"
                  :data-vv-as="labels.rem1"
                  v-validate="'numeric|max:2'"
                  :disabled="rem1Disabled"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 v-if="form.procType == 'A'">
                <v-text-field
                  v-model="form.rem2"
                  :label="labels.rem2"
                  :error-messages="errors.collect('rem2')"
                  data-vv-name="rem2"
                  :data-vv-as="labels.rem2"
                  v-validate="'numeric|max:2'"
                  :disabled="rem2Disabled"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 v-if="form.procType == 'A'">
                <v-text-field
                  v-model="form.rem3"
                  :label="labels.rem3"
                  :error-messages="errors.collect('rem3')"
                  data-vv-name="rem3"
                  :data-vv-as="labels.rem3"
                  v-validate="'numeric|max:2'"
                  :disabled="rem3Disabled"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.effDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.effDate) }}</div>
              </v-flex>
              <v-flex xs12 md6 v-else>
                <cal-picker
                  :label="labels.effDate"
                  v-model="form.effDate"
                  :error-messages="errors.collect('effDate')"
                  data-vv-name="effDate"
                  :data-vv-as="labels.effDate"
                  v-validate="effDateValidation"
                ></cal-picker>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="form.defGenDoc"
                  :label="labels.defGenDoc"
                  :error-messages="errors.collect('defGenDoc')"
                  data-vv-name="defGenDoc"
                  :data-vv-as="labels.defGenDoc"
                  :disabled="disabledGenDoc"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="form.defEmailRecip"
                  :label="labels.defEmailRecip"
                  :error-messages="errors.collect('defEmailRecip')"
                  data-vv-name="defEmailRecip"
                  :data-vv-as="labels.defEmailRecip"
                  :disabled="disabledGenDoc"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="form.defSMSRecip"
                  :label="labels.defSMSRecip"
                  :error-messages="errors.collect('defSMSRecip')"
                  data-vv-name="defSMSRecip"
                  :data-vv-as="labels.defSMSRecip"
                  :disabled="disabledGenDoc"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="form.defEmailAgt"
                  :label="labels.defEmailAgt"
                  :error-messages="errors.collect('defEmailAgt')"
                  data-vv-name="defEmailAgt"
                  :data-vv-as="labels.defEmailAgt"
                  :disabled="disabledGenDoc"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="form.defSMSAgt"
                  :label="labels.defSMSAgt"
                  :error-messages="errors.collect('defSMSAgt')"
                  data-vv-name="defSMSAgt"
                  :data-vv-as="labels.defSMSAgt"
                  :disabled="disabledGenDoc"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 v-if="!newMode">
                <v-textarea
                  v-model="form.text"
                  :label="labels.text"
                  :error-messages="errors.collect('text')"
                  data-vv-name="text"
                  :data-vv-as="labels.text"
                  :counter="1000"
                  :rows="4"
                  :disabled="disabledGenDoc"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 v-else>
                <v-textarea
                  v-model="form.text"
                  :label="labels.text"
                  :error-messages="errors.collect('text')"
                  v-validate="'max:1000|entry'"
                  data-vv-validate-on="change"
                  data-vv-name="text"
                  :data-vv-as="labels.text"
                  :counter="1000"
                  :rows="4"
                  :disabled="disabledGenDoc"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  v-model="users"
                  :disabled="disabledNotify"
                  :items="usersList"
                  :search-input="searchText"
                  filled
                  chips
                  color="blue-grey lighten-2"
                  label="Users to notify"
                  item-text="name"
                  item-value="id"
                  ref="autocomplete"
                  multiple
                  @change="clearSearchInput"
                >
                  <template v-slot:selection="data">
                    <v-chip v-bind="data.attrs" :input-value="data.selected" close @input="removeUser(data.item)" @click:close="removeUser(data.item)">
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.email }}</v-list-item-subtitle>
                        <v-divider></v-divider>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="form.crtToDo"
                  :label="labels.crtToDo"
                  :error-messages="errors.collect('crtToDo')"
                  data-vv-name="crtToDo"
                  :data-vv-as="labels.crtToDo"
                  :disabled="disabledNotify"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox
                  v-model="form.initSched"
                  :label="labels.initSched"
                  :error-messages="errors.collect('initSched')"
                  data-vv-name="initSched"
                  :data-vv-as="labels.initSched"
                  :disabled="disabledInitSched"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 md6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.schedFreq }}</v-subheader>
                <div class="queryValue" v-for="item in filteSchedFreqList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <!-- <v-flex xs12 md6 v-else>
                <v-autocomplete :label="labels.schedFreq" :items="schedFreqList" v-model="form.schedFreq" item-text="value" item-value="code" data-vv-name="schedFreq" :data-vv-as="labels.schedFreq" :error-messages="errors.collect('schedFreq')" :disabled="disabledInitSched"></v-autocomplete>
              </v-flex> -->
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs12 md6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs12 md6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs12 md6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs12 md6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
            <span>Cancel</span>
            <v-icon right dark>mdi-cancel</v-icon>
          </v-btn>
          <v-btn :disabled="queryMode" color="primary" dark @click="doSave" :loading="submitting">
            {{ newMode ? 'Save' : '' }}{{ reviewMode ? 'Update' : '' }}
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="userList" width="1000px" persistent>
        <UserHelplist v-if="userListHelplist" @select="doAssign($event)" @close="doClose"></UserHelplist>
      </v-dialog>
      <v-dialog v-model="scheduleJobModal" width="1000px" persistent>
        <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import { procId, procType, schedFreq } from '@/const/params'
import UserHelplist from '../helplist/UserHelplist'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'

export default {
  data() {
    return {
      labels: {
        procId: 'Process ID',
        procType: 'Process Type',
        effDate: 'Effective Date',
        defGenDoc: 'Auto generate document',
        defEmailRecip: 'Email main recipient',
        defEmailAgt: 'Email agent',
        defSMSRecip: 'SMS main recipient',
        defSMSAgt: 'SMS agent',
        text: 'Email / SMS text',
        toNotify: 'Users to notify',
        crtToDo: 'Auto create TO DO task',
        initSched: 'Auto initiate Scheduler task',
        schedFreq: 'Schedule frequency',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        alert: 'Alert',
        rem1: '1st Reminder (days after Alert)',
        rem2: '2nd Reminder (days after 1st Reminder)',
        rem3: '3rd Reminder (days after 2nd Reminder)'
      },
      form: {
        procId: null,
        procDesc: '',
        procType: '',
        effDate: '',
        defGenDoc: false,
        defEmailRecip: false,
        defEmailAgt: false,
        defSMSRecip: false,
        defSMSAgt: false,
        text: '',
        toNotify: '',
        crtToDo: false,
        initSched: false,
        schedFreq: '',
        alert: 0,
        rem1: 0,
        rem2: 0,
        rem3: 0
      },
      procType: {
        procId_A_start: 201,
        procId_D_start: 620,
        procId_A_end: 299,
        procId_D_end: 699,
        procId_A_List: [],
        procId_D_List: []
      },
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      disabledGenDoc: true,
      disabledNotify: true,
      disabledInitSched: true,
      userList: false,
      userListHelplist: false,
      usersList: [],
      users: [],
      searchText: '',
      scheduleJobModal: false,
      showScheduleJob: false,
      jobName: '',
      jobDesc: ''
    }
  },
  methods: {
    async doInit() {
      this.doSetProcTypeList()
      if (this.newMode) {
        this.fetchUsers()
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getProcNotif
      if (apiURI) {
        this.loading = true
        const expand = {
          procId: this.objParam.procId
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.procId = data.procNotif.procId
            this.form.procType = data.procNotif.procType
            this.form.effDate = data.procNotif.effDate
            this.form.defGenDoc = data.procNotif.defGenDoc
            this.form.defEmailRecip = data.procNotif.defEmailRecip
            this.form.defEmailAgt = data.procNotif.defEmailAgt
            this.form.defSMSRecip = data.procNotif.defSMSRecip
            this.form.defSMSAgt = data.procNotif.defSMSAgt
            this.form.text = data.procNotif.text
            this.form.toNotify = data.procNotif.toNotify
            this.form.crtToDo = data.procNotif.crtToDo
            this.form.initSched = data.procNotif.initSched
            this.form.schedFreq = data.procNotif.schedFreq
            this.form.alert = data.procNotif.alert
            this.form.rem1 = data.procNotif.rem1
            this.form.rem2 = data.procNotif.rem2
            this.form.rem3 = data.procNotif.rem3
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
          if (this.form.procId !== null) {
            this.doSetProcDesc()
            this.jobDesc = this.form.procDesc
            if (this.form.procId === 'C202') {
              this.jobName = 'qrtzClaimPendingRegistrationNotif'
              this.showScheduleJob = true
            }
          }
          if (this.reviewMode) {
            this.doSetProcType()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async fetchUsers() {
      const apiUrl = this.menu.getUserList
      if (apiUrl) {
        this.$http
          .get(expandURI(apiUrl))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.usersList = []
              data.map((datamap) => {
                const userList = {
                  id: datamap.uid,
                  email: datamap.email,
                  name: datamap.firstName + ' ' + datamap.lastName
                }
                this.usersList.push(userList)
              })
            }
            if (this.form.toNotify !== '') {
              this.doAssignEmail()
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCancel() {
      this.$router.push({ name: 'procNotif' })
    },
    doSave() {
      this.doSetProcDesc()
      this.doSetUserId()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createProcNotif
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateProcNotif
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSetProcTypeList() {
      while (this.procType.procId_A_start <= this.procType.procId_A_end) {
        this.procType.procId_A_List.push('C' + this.procType.procId_A_start)
        this.procType.procId_A_start++
      }
      while (this.procType.procId_D_start <= this.procType.procId_D_end) {
        this.procType.procId_D_List.push('C' + this.procType.procId_D_start)
        this.procType.procId_D_start++
      }
    },
    async doSetProcType() {
      if (this.procType.procId_A_List.some((procIdx) => procIdx === this.form.procId)) {
        this.doSetProcDesc()
        this.form.procType = 'A'
        this.form.defGenDoc = false
        this.form.defEmailRecip = false
        this.form.defEmailAgt = false
        this.form.defSMSRecip = false
        this.form.defSMSAgt = false
        this.disabledGenDoc = true
        this.disabledNotify = false
        if (this.form.procId === 'C202') {
          this.disabledInitSched = false
        } else {
          this.form.schedFreq = ''
          this.disabledInitSched = true
        }
      }
      if (this.procType.procId_D_List.some((procIdx) => procIdx === this.form.procId)) {
        this.form.procType = 'D'
        this.form.crtToDo = false
        this.form.initSched = false
        this.form.schedFreq = ''
        this.disabledGenDoc = false
        this.disabledNotify = true
        this.disabledInitSched = true
      }
    },
    doSetProcDesc() {
      this.procIdList.filter((list) => {
        if (list.code === this.form.procId) {
          var n = 2 // second space
          var a = list.value.split(' ')
          var value = a.slice(n).join(' ')
          this.form.procDesc = value
        }
      })
    },
    async doSetUserId() {
      this.form.toNotify = ''
      for (let i in this.users) {
        this.form.toNotify += this.users[i] + ','
      }
      this.form.toNotify = this.form.toNotify.slice(0, -1)
    },
    async doAssignEmail() {
      if (this.form.toNotify !== '' && this.form.toNotify !== undefined) {
        var user = this.form.toNotify.split(',')
        this.usersList.filter((item) => {
          user.map((uid) => {
            var item1 = item.id
            var item2 = parseInt(uid)
            if (item1 === item2) {
              this.users.push(item2)
            }
          })
        })
      }
    },
    getHelpList() {
      this.userList = true
      this.userListHelplist = true
    },
    doClose() {
      this.userList = false
      this.userListHelplist = false
    },
    async doAssign(users) {
      this.form.toNotify = ''
      for (var i = 0; i < users.length; i++) {
        this.form.toNotify += users[i].id + ','
      }
      this.form.toNotify = this.form.toNotify.slice(0, -1)
    },
    removeUser(item) {
      const index = this.users.indexOf(item.id)
      if (index > -1) {
        this.users.splice(index, 1)
      }
    },
    clearSearchInput() {
      setTimeout(() => {
        this.searchText = ''
        this.$refs.autocomplete.blur()
      }, 0)
    }
  },
  computed: {
    rem1Disabled() {
      return this.disabledNotify || isNaN(this.form.alert) || this.form.alert <= 0
    },
    rem2Disabled() {
      return this.disabledNotify || isNaN(this.form.rem1) || this.form.rem1 <= 0
    },
    rem3Disabled() {
      return this.disabledNotify || isNaN(this.form.rem2) || this.form.rem2 <= 0
    },
    menu() {
      return this.$store.state.procNotifParam.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    },
    effDateValidation() {
      return 'required'
    },
    procIdList() {
      let result = []
      Object.keys(procId).forEach(function (key) {
        const status = procId[key]
        result.push({
          code: key,
          value: status
        })
      })
      return result
    },
    filterProcIdList() {
      return this.procIdList.filter((list) => {
        return list.code === this.form.procId
      })
    },
    procTypeList() {
      let result = []
      Object.keys(procType).forEach(function (key) {
        const status = procType[key]
        result.push({
          code: key,
          value: status
        })
      })
      return result
    },
    filterProcTypeList() {
      return this.procTypeList.filter((list) => {
        return list.code === this.form.procType
      })
    },
    schedFreqList() {
      let result = []
      Object.keys(schedFreq).forEach(function (key) {
        const status = schedFreq[key]
        result.push({
          code: key,
          value: status
        })
      })
      return result
    },
    filteSchedFreqList() {
      return this.schedFreqList.filter((list) => {
        return list.code === this.form.schedFreq
      })
    }
  },
  created() {
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  mounted() {
    this.doInit()
  },
  watch: {
    'form.toNotify': function (value) {
      if (value !== '' && !this.newMode) {
        this.fetchUsers()
      }
    },
    rem1Disabled: function (value) {
      if (value === true) {
        this.form.rem1 = 0
      }
    },
    rem2Disabled: function (value) {
      if (value === true) {
        this.form.rem2 = 0
      }
    },
    rem3Disabled: function (value) {
      if (value === true) {
        this.form.rem3 = 0
      }
    }
  },
  mixins: [MessageMixin],
  components: {
    ScheduleJob,
    UserHelplist
  }
}
</script>
